import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Toote info

  <span style="color:#85c1dc;">**FI:**</span>
  Tuotetiedot

  <span style="color:#85c1dc;">**RU:**</span>
  Информация о товаре
*/
/* @__NO_SIDE_EFFECTS__ */
const m1031 = msg(
  mf`Toote info`,
  mf`Tuotetiedot`,
  mf`Информация о товаре`,
)

export { m1031 as 'w.module.product_description.product_info' }